import { ModuleWithProviders, NgModule, Pipe, PipeTransform } from '@angular/core';
import { ILocalizationManager, LocalizationManager } from '@mosaik/core';

/**
 * @public
 */
@Pipe({
  name: 'localizeAsync'
})
export class LocalizeAsyncPipe implements PipeTransform {
  private readonly _localizationManager: ILocalizationManager;

  public constructor(localizationManager: LocalizationManager) {
    this._localizationManager = localizationManager;
  }

  public transform(value: string, ...args: Array<any>): Promise<string> {
    const raw = args[2] || false;
    if (raw) {
      return Promise.resolve(value);
    }
    return this._localizationManager.getLocalizationAsync(value, args[0], args[1]);
  }
}

/**
 * @public
 */
@NgModule({
  declarations: [LocalizeAsyncPipe],
  exports: [LocalizeAsyncPipe]
})
export class LocalizeAsyncPipeModule {
  public static forRoot(): ModuleWithProviders<LocalizeAsyncPipeModule> {
    return {
      ngModule: LocalizeAsyncPipeModule,
      providers: [LocalizationManager]
    };
  }
}
